// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_mK1","cls2":"FocusedNav-cls2_Av6 FocusedNav-cls1_mK1","inDevStyle":"FocusedNav-inDevStyle_GVI","useGrid":"FocusedNav-useGrid_eqh"};